import * as React from 'react'
import { Field } from 'react-final-form';


export interface OnChangeProps {
  name: string,
  children: <T>(value: T, previous: T) => void;
}

type Props = {
  children: (value: unknown, previous: unknown) => void,
  input: {
    value: unknown
  }
}

type State = {
  previous: unknown
}

class OnChangeState extends React.Component<Props, State> {
  props: Props
  state: State

  constructor(props: Props) {
    super(props)
    this.state = {
      previous: props.input.value
    }
  }

  componentDidUpdate() {
    const { children, input: { value } } = this.props
    const { previous } = this.state
    if (value !== previous) {
      this.setState({ previous: value })
      children(value, previous)
    }
  }

  render() {
    return null
  }
}

const OnChange = ({ name, children }: OnChangeProps) =>
  React.createElement(Field, {
    name,
    subscription: { value: true },
    allowNull: true,
    render: (props) => React.createElement(OnChangeState, { ...props, children })
  })

export default OnChange
